import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { routeHistory } from '@nackle/biw-web-router';
import { Navigation } from '../../../navigation';

import './styles.less';

export const Link = ( props ) => {
    // Construct the classes to use for the root component.
    const classes = classnames(
        'link-item',
        { [ props.className ]: Boolean( props.className ) },
    );

    const handleClick = useCallback( () => {
        let path = props.to;

        // If a function is provided for the `to` property, call it expecting
        // a string to be returned to get the new path to navigate to.
        if ( typeof props.to === 'function' ) {
            const previousRouteParams = routeHistory?.route?.state?.params;
            path = props.to( previousRouteParams ? previousRouteParams : {} );
        } 

        if ( props.back ) {
            Navigation.back();
        } else if ( props.replace ) {
            Navigation.replace( path, { props: props.toProps } );
        } else {
            Navigation.push( path, { props: props.toProps } );
        }

        // Execute click callback if provided.
        if ( props.onClick ) {
            props.onClick();
        }
    }, [ props ] );

    const handleKeyUpEvent = useCallback( ( e ) => {
        e.preventDefault();
        const spaceKey = ( e.keyCode === 32 );
        const enterKey = ( e.keyCode === 13 );

        if ( props.to || props.back || props.replace ) {
            if ( enterKey ) {
                handleClick();
            }
        } else if ( props.onClick ) {
            if ( spaceKey || enterKey ) {
                handleClick();
            }
        }
    }, [ handleClick, props.to, props.back, props.replace, props.onClick ] );

    return (
        <span id={ props.id } className={ classes }>
            { ( props.newTab )
                ? (
                    <a
                        tabIndex={ ( props.tabIndex !== undefined ) ? props.tabIndex : 0 }
                        href={ props.href }
                        target={ '_blank' }
                        rel={ 'noopener noreferrer' }
                        onClick={ handleClick }
                        onKeyUp={ handleKeyUpEvent }
                        className={ props.linkClass }
                    >
                        { props.children }
                    </a>
                )
                : (
                    <a
                        tabIndex={ ( props.tabIndex !== undefined ) ? props.tabIndex : 0 }
                        href={ props.href }
                        onClick={ handleClick }
                        onKeyUp={ handleKeyUpEvent }
                        className={ props.linkClass }
                    >
                        { props.children }
                    </a>
                )
            }
        </span>
    );
};

Link.defaultProps = {
    tabIndex: 0,
};

Link.propTypes = {
    className: PropTypes.string,
    linkClass: PropTypes.string,
    id: PropTypes.string,
    to: PropTypes.string,
    href: PropTypes.string,
    toProps: PropTypes.object,
    newTab: PropTypes.bool,
    replace: PropTypes.bool,
    back: PropTypes.bool,
    onClick: PropTypes.func,
    tabIndex: PropTypes.oneOfType( [ PropTypes.string, PropTypes.number ] ),
};
